import React from "react";

import "./alternative-icon.css";
import { SvgIcon } from "../svg-icon";

/**
 * The Icon that is used to show an Alternative Option (later Alternative Product, Alternative Color)
 */
export function AlternativeIcon({
	svgUrl,
	color,
	overlayColor,
	orientation = "undefined",
}: {
	svgUrl?: string;
	color?: string;
	overlayColor?: string;
	orientation?: "vertical" | "horizontal" | "undefined";
}) {
	// Large Color dot
	if (!svgUrl && overlayColor) {
		return (
			<div className="alternative-icon">
				<div
					className="alternative-icon__large-overlay-color"
					style={{ backgroundColor: overlayColor }}
				/>
			</div>
		);
	}

	// Icon with optional overlay
	if (svgUrl) {
		return (
			<div className="alternative-icon">
				<SvgIcon svgUrl={svgUrl} rotated={orientation === "vertical"} color={color} />
				{overlayColor && (
					<div
						className="alternative-icon__small-overlay-color"
						style={{ backgroundColor: overlayColor }}
					/>
				)}
			</div>
		);
	}

	// No Icon or dot
	return null;
}
